import React from "react"
import { connect } from "react-redux"
import styled from "@emotion/styled"
import {Box } from "@rebass/grid/emotion"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"

import CloseIcon from '-!svg-react-loader!../../assets/icons/nova/close-icon.svg'
import { clearStateAndExit } from "../../utils/clearStateAndExit"
import { setCurrentSection } from "../../actions"

import {
  sectionNameToId,
  sectionNameToNum,
  formattedSectionName,
} from "../../utils/segmentHelpers"

const FakeLink = styled.button`
  display: flex;
  margin-left: auto;
  align-items: center;
  //padding-bottom: 2px;
  border-bottom: 1px solid ${theme.wild.color.master.base.black};
  gap: 4px;
  
  svg {
    width: 16px;
    height: 16px;
    @media (min-width: 1024px) {
      width: 20px;
      height: 20px;
    }
  }
  p {

    line-height:100% !important;
    @media (min-width: 768px) {
     // line-height: 14px !important;
    }
    @media (min-width: 1024px) {
    //  line-height: 20px !important;
    }
  }

`

const SaveAndExitButton = props => {

  const clearStateSetLocation = () => {

    if (window.location.pathname.indexOf("results") > -1) {
      segmentEvent('Quiz Clicked Exit', {
        "quiz_version": process.env.GATSBY_QUIZ_VERSION,
        "section_name": 'results',
        "token": props.token,
      })
    } else {
      // getting the current Q id and text from JSON + localstorage
      let quizJson = JSON.parse(localStorage.getItem("quizJson"))
      let sectionNum = sectionNameToNum(props.currentSection)
      let quizProgress = localStorage.getItem("quizProgress") ? parseInt(localStorage.getItem("quizProgress")) : 0
      let sectionJson = quizJson?.[sectionNum] ? quizJson[sectionNum] : quizJson?.sections?.[sectionNum] ? quizJson.sections[sectionNum] : ""
      let currentQuestionJson = sectionJson?.questions?.[quizProgress] ? sectionJson.questions[quizProgress] : sectionJson[quizProgress]
      let currentQuestionText = currentQuestionJson?.text ? currentQuestionJson.text : ""
      let currentQuestionId = currentQuestionJson?.id ? currentQuestionJson.id : ""
      
      segmentEvent('Quiz Clicked Exit', {
        "question": currentQuestionText,
        "question_id": currentQuestionId,
        "quiz_version": process.env.GATSBY_QUIZ_VERSION,
        "section_id": sectionNameToId(props.currentSection),
        "section_name": formattedSectionName(props.currentSection),
        "token": props.token,
      })
    }

    setTimeout(() => {
      clearStateAndExit()
    }, 250)

  }

  return (
    <FakeLink onClick={() => clearStateSetLocation()} className={"exit-link"}>
      <Box>
        <TextElementNova text={`Exit`} element="p" className=" text-nova-base-black show-small-only CTA-10-Dia-Normal" />
        <TextElementNova text={`Exit Quiz`} element="p" className=" text-nova-base-black hide-small-only CTA-10-Dia-Normal" />
      </Box>
      <Box>
        <CloseIcon className="exit-icon" />
      </Box>
    </FakeLink>
  )
}

const mapStateToProps = state => {
  return {
    quizProgress: state.progressReducer.quizProgress,
    currentSection: state.sectionReducer.currentSection,
    token: state.tokenReducer.token,
    currentGlobalId: state.globalIdReducer.currentGlobalId,
  }
}

export default connect(mapStateToProps, { setCurrentSection })(SaveAndExitButton)